import { Pressable, Text, View } from "react-native";
import { ChevronDown } from "lucide-react-native";
import { colors, semanticColors, typography } from "../theme/tokens";
import { MoonText } from "./MoonText";
import type { MoonPhoneCountry } from "../phoneCountries";

export type MoonPhoneCountrySelectorProps = {
  country: MoonPhoneCountry;
  onPress: () => void;
  disabled?: boolean;
  testID?: string;
  appearance?: "default" | "glass";
};

export function MoonPhoneCountrySelector({
  country,
  onPress,
  disabled,
  testID,
  appearance = "default",
}: MoonPhoneCountrySelectorProps) {
  const isGlass = appearance === "glass";

  return (
    <>
      <Pressable
        testID={testID}
        accessibilityRole="button"
        accessibilityLabel={`Country: ${country.name}, ${country.dialCode}. Tap to change.`}
        onPress={onPress}
        disabled={disabled}
        hitSlop={6}
      >
        {isGlass ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingHorizontal: 10,
              paddingVertical: 10,
              gap: 4,
            }}
          >
            <Text style={{ fontSize: 16 }}>{country.flag}</Text>
            <Text
              style={{
                fontFamily: typography.families.sans,
                fontSize: 15,
                color: semanticColors.onDark.text.primary,
                fontWeight: "500",
              }}
            >
              {country.dialCode}
            </Text>
            <ChevronDown
              size={14}
              color={semanticColors.onDark.text.tertiary}
              strokeWidth={2}
            />
          </View>
        ) : (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexShrink: 0,
              paddingHorizontal: 4,
              paddingVertical: 0,
              borderRadius: 6,
            }}
          >
            <View
              style={{
                height: 18,
                width: 18,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MoonText
                style={{
                  fontSize: 14,
                  lineHeight: 18,
                  textAlign: "center",
                  transform: [{ translateY: 2 }],
                }}
                accessibilityElementsHidden
              >
                {country.flag}
              </MoonText>
            </View>
            <MoonText
              style={{
                fontFamily: typography.families.sansMedium,
                fontSize: 14,
                fontWeight: "500",
                color: colors.textMid,
                flexShrink: 0,
                marginLeft: 3,
              }}
            >
              {country.dialCode}
            </MoonText>
            <ChevronDown
              size={9}
              color={colors.textFaint}
              strokeWidth={2}
              style={{ marginLeft: 3 }}
            />
          </View>
        )}
      </Pressable>
      {isGlass ? (
        <View
          style={{
            width: 1,
            height: 20,
            backgroundColor: semanticColors.onDark.fill.strong,
            marginRight: 12,
          }}
        />
      ) : null}
    </>
  );
}
